import { render, staticRenderFns } from "./FormBuy.vue?vue&type=template&id=4f9b5710&scoped=true&"
import script from "./FormBuy.vue?vue&type=script&lang=js&"
export * from "./FormBuy.vue?vue&type=script&lang=js&"
import style0 from "./FormBuy.vue?vue&type=style&index=0&id=4f9b5710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b5710",
  null
  
)

export default component.exports